import { FaAws } from 'react-icons/fa'

export const AWSTech = () => {
    return (
        <div>
        <FaAws />
        <h4>AWS</h4>
        </div>
    )
}